export default __webpack_public_path__ + "static/media/orderconfirmation.032c8587.png";